import { logger } from 'bernie-core';
import * as React from 'react';
import { get } from 'lodash';

import { checkValue, removeImageURLCropParams, getCurlyQuotes, capitalizeFirst } from 'src/components/common/helper';
import { HeroProps, BreadCrumbProps } from 'src/components/common/module-util';
import { VideoProps, Video } from 'src/components/common/modules/video-player/video';
import { CopyrightWithGradientComponent , CopyrightCameraProps } from 'src/components/common/modules/copyright-with-gradient/code-split/copyright-with-gradient-component';
import BreadCrumb from 'src/components/common/modules/breadcrumb/breadcrumb';
import { Typo } from 'src/components/common/ui';
import VideoPlayerComponent from 'src/components/common/modules/video-player/code-split/video-player-component';
import { getDeviceImage } from 'src/components/common/theme/component';
import {
  mediaQueries,
  setFontSizeHeroModule,
} from 'src/components/common/theme/component-styles';

let heroLargImg = '';

@logger('spotlightpage')
export class Hero extends React.PureComponent<HeroProps, any> {
  public constructor(props) {
    super(props);
    this.handleResize = this.handleResize.bind(this);
  }

  private handleResize = () =>{
    this.setScrollArrowBottom();
  }

  public componentDidMount() {
    ///////

    if (!('addEventListener' in window)) {
      return;
    }

    window.addEventListener('resize', this.handleResize);
    
    this.setScrollArrowBottom();

    
    const win = window;
    const doc = win.document;
    const img = new Image();
    const header = doc.querySelector('.t-hero-image');
    const enhancedClass = 't-hero-image-large';

    const bigSrc = (function () {
      const bgStyle = heroLargImg !== '' ? heroLargImg : '';
      return bgStyle;
    })();

    // Assign an onLoad handler to the dummy image *before* assigning the src
    img.onload = function () {
      header.className += ' ' + enhancedClass;
    };
    // Finally, trigger the whole preloading chain by giving the dummy
    // image its source.
    if (bigSrc) {
      img.src = bigSrc;
    }    
    ///////
  }

  public setScrollArrowBottom(){
    const heroData = this.props;
      if(checkValue(heroData?.heroScrollDownArrow) && (heroData?.heroScrollDownArrow === 'True')){
          const globalHeaderElem = document.querySelector<HTMLElement>('.header-main-container');
          const globalHeaderHeight = checkValue(globalHeaderElem)?globalHeaderElem?.offsetHeight:128;
          const heroHeight = document.querySelector<HTMLElement>('.t-hero-wrapper').offsetHeight;
          const viewPortHeight = window.innerHeight;

          let scrollArrowBottom = 0;
          if((heroHeight + globalHeaderHeight) > (viewPortHeight)){
            scrollArrowBottom = (globalHeaderHeight + heroHeight) - (viewPortHeight) + 45;  
          }else{
            if(window.innerWidth > 1440){
              scrollArrowBottom = 275.06;
            }else{
              scrollArrowBottom = 157.06;
            }
          }
          
          document.querySelector<HTMLElement>('.scroll_arrow').style.bottom = scrollArrowBottom + 'px';
          document.querySelector<HTMLElement>('.scroll_arrow').style.visibility = 'visible';
      }
  }
  
  
  public render() {
    const isMobile = document.body.offsetWidth < 768;
    const heroData = this.props;  
    const { partner, templateName, feedName } = heroData.breadcrumb;
    const applyOriginalRatioForBackgroundPhoto = heroData?.applyOriginalRatioForBackgroundPhoto;
    const heroSlimMode = heroData?.heroSlimMode;
 
    let heroTitle = heroData.heroTitleDesktop;
    let heroSubText = heroData.heroSubTextDesktop;
    const turnOffImagecrop = heroData.turnOffCropsForHeroImage;

    if (heroData.device !== 'desktop') {
      if (heroData.heroTitleMobile && heroData.heroTitleMobile !== '') {
        heroTitle = heroData.heroTitleMobile;
      }
      if (heroData.heroSubTextMobile && heroData.heroSubTextMobile !== '') {
        heroSubText = heroData.heroSubTextMobile;
      }
    }

    let heroImage: string, herotinyImage: string;
    heroImage = '';
    herotinyImage = '';
    let herotinyFilterDev = 'hero-tiny-desktop';
    if (checkValue(heroData.heroImageNew, true)) {
      let heroFilterDev = 'hero-desk';
      if (checkValue(heroData.heroImageNew, true)) {
        if (heroData.device === 'tablet') {
          heroFilterDev = 'hero-tab';
          herotinyFilterDev = 'hero-tiny-tablet';
        } else if (heroData.device === 'mobile' && !turnOffImagecrop) {
          heroFilterDev = 'hero-mob';
          herotinyFilterDev = 'hero-tiny-mobile';
        }
        const arrFiltered = heroData.heroImageNew.filter((heroItem) => heroItem.name.includes(heroFilterDev));
        if (checkValue(arrFiltered, true)) {
          heroImage =(isMobile && checkValue(heroData.heroImageMobile))?heroData?.heroImageMobile[0].url:arrFiltered[0].url;
          heroLargImg =(isMobile && checkValue(heroData.heroImageMobile))?heroData?.heroImageMobile[0].url:arrFiltered[0].url;
        }
        const arrtinyFiltered = heroData.heroImageNew.filter((heroItem) => heroItem.name.includes(herotinyFilterDev));
        if (checkValue(arrtinyFiltered, true)) {
          herotinyImage = (isMobile && checkValue(heroData.heroImageMobile))?heroData?.heroImageMobile[0].url:arrtinyFiltered[0].url;
        }
      }
    }

    // crop params remove from Image URL
    const newHerotinyImage: string = removeImageURLCropParams(herotinyImage);

    const herotinyBackgroundImage = {
      backgroundImage: `url(${newHerotinyImage})`,
    };
    const herobgImg = herotinyBackgroundImage;

    const getSubText = () => {
      if (heroSubText) {
        return (
          <div className="uitk-cell all-cell-1-1 m-cell-1-1 s-cell-1-1">
            <div className="t-hero-paragraph">
              <Typo.HTMLText tag="p" exClass="hero-sub-head hero-sub-head-color">
                {heroSubText}
              </Typo.HTMLText>
            </div>
          </div>
        );
      }
    };

    const getTemplateType = () => {
      let teplateType = '';
      if (this.props.template.includes('article')) {
        teplateType = 'article';
      }
      if (this.props.template.includes('gallery')) {
        teplateType = 'gallery';
      }
      if (this.props.template.includes('itinerary')) {
        teplateType = 'itinerary';
      }
      if (this.props.template.includes('listicle')) {
        teplateType = 'listicle';
      }
      return teplateType;
    };

    const copyrightCameraProps: CopyrightCameraProps = {
      copyrightText: heroData.heroImageCopyright,
      copyrightCation: heroData.heroImageCopyrightCaption,
      iconSize:"sm"
    };

    const { heroLogo, heroLogoStyle, heroOverlayImageDesktop, heroOverlayImageMobile, breadcrumbCurrentCopy, breadcrumbHomeCopy } = heroData;
    const heroLogoImage = getDeviceImage(heroLogo, 'desktop');
    const heroLogoAlign = checkValue(heroLogoStyle) ? heroLogoStyle.replace(/\s/g, '').toLowerCase() : 'left';

    const heroOverlayImage = (heroData.device === 'mobile') ?  checkValue(heroOverlayImageMobile, true) ? heroOverlayImageMobile : heroOverlayImageDesktop : heroOverlayImageDesktop;
    const isheroLogoFull = checkValue(heroOverlayImage, true);

    const getBreadcums = () => {
      if(checkValue(partner) && partner.toLowerCase() === "spotlight") {
        return null
      } 
      if (heroData?.turnOffBreadcrumb?.toLowerCase() === 'true') return null;
      const { mccidData } = heroData.breadcrumb;

      const mcicdTrackings: BreadCrumbProps['expTracking'] = { 
        templateType: checkValue(mccidData.templateType) ? mccidData.templateType : '',
        campaignUrl: checkValue(mccidData.campaignUrl) ? mccidData.campaignUrl : '',
        mainUrl:  checkValue(mccidData.mainUrl) ? mccidData.mainUrl : '',
        referrerId: checkValue(mccidData.referrerId) ? mccidData.referrerId : '',
      };

      const crumbs: BreadCrumbProps['BreadCrumbs'] = [
        { DisplayName: checkValue(breadcrumbCurrentCopy) ? breadcrumbCurrentCopy : capitalizeFirst(feedName), Value: partner + '/' + templateName + '/' + feedName }
      ]; 
                
        return <BreadCrumb homeHref={partner + '/' + templateName} homeLoc={ checkValue(breadcrumbHomeCopy) ? breadcrumbHomeCopy : 'Home'} BreadCrumbs={...crumbs} expTracking={mcicdTrackings} />;
    };

    const getHeroLogoCentered = () => {      
      return (
        <>       
          {
            checkValue(heroLogoImage) && heroLogoAlign.toLowerCase() === 'centered' && !isheroLogoFull && 
              <div className="spotlight-component-wrapper">
                <div className={`hero-logo-center hero-logo-${heroLogoAlign}`}>
                  <img src={heroLogoImage} />
                </div>
              </div>
          }
          {
            checkValue(isheroLogoFull) && isheroLogoFull && 
              <div className="spotlight-component-wrapper-full">
                <div className={`hero-logo-center-full`}>
                  <img src={getDeviceImage(heroOverlayImage, 'desktop')} />
                </div>
              </div>
          }
        </>
      );
    };

    const handleScroll = () => {
      const heroBanner = document.querySelector<HTMLElement>('.t-hero-wrapper');
      const headerOffsetHeight = document.querySelector<HTMLElement>('.header-main-container').offsetHeight;
      if (checkValue(heroBanner)) {
        setTimeout(() => {
          window.scrollTo({
            behavior: 'smooth',
            top: heroBanner.nextElementSibling.getBoundingClientRect().top - document.body.getBoundingClientRect().top - headerOffsetHeight,
          });
        }, 400)
      }
    };
  
    const setScrollDownArrow = () => {   
        return (
          <div className="scroll_arrow controls container bg__figure">
            <span className="controls__arrow" onClick={handleScroll}>
              <span></span>
              <span></span>
            </span>
          </div>
        );
    };  
    

    const getHeroHTML = () => {
      let videoHTML: any = '';
      let isVideoMode: boolean;
      let heroShadowNone: string;
      let heroBackgroundVideoHTML: any = '';
      let isHeroBgVideoMode: boolean;
      let heroTitlesWrapper: string;
      let heroTitleStyle: string;
      let heroGradient: string;
      let wrapperClass = 't-hero-wrapper t-paragraph-wrapper';
      isVideoMode = false;
      heroShadowNone = '';
      isHeroBgVideoMode = false;
      heroTitlesWrapper = 'uitk-cell all-cell-1-1 m-cell-1-1 s-cell-1-1';
      heroTitleStyle = 't-hero-title-text-left';
      heroGradient = 'left-text-gradient';

      if (this.props.heroStyle === 'Article Style 1') {
        heroTitleStyle = 't-hero-title-text-left';
        heroGradient = 'left-text-gradient';
      } else if (this.props.heroStyle === 'Article Style 2') {
        heroTitleStyle = 't-hero-title-text-bottom';
        heroGradient = 'bottom-text-gradient';
      } else if (this.props.heroStyle === 'Article Style 3') {
        heroTitleStyle = 't-hero-title-text-center';
        heroGradient = 'center-text-gradient';
      }
      if (this.props.turnOffGradient && this.props.turnOffGradient.toLocaleLowerCase() !== 'false') {
        heroGradient = '';
        heroShadowNone = ' t-hero-image-shadow';
      }
      let videoJsOptions = {};

      //check for hero video
      if (checkValue(this.props.heroVideo, true) || checkValue(this.props.heroVideoId, true)) {
        if (checkValue(this.props.heroVideo, true)) {
          const heroVideoURL = this.props.heroVideo[0]['url'];
          videoJsOptions = {
            autoplay: false,
            controls: true,
            siteid: this.props.siteid,
            campaignUrl: this.props.campaignUrl,
            template: this.props.template,
            sources: [
              {
                src: heroVideoURL,
                type: 'video/mp4',
              },
            ],
          };
        } else if (checkValue(this.props.heroVideoId, true)) {
          if (this.props.heroVideoType === 'YouTube') {
            videoJsOptions = {
              techOrder: ['youtube'],
              autoplay: false,
              controls: true,
              sources: [
                {
                  src: this.props.heroVideoId,
                  type: 'video/youtube',
                },
              ],
            };
          }
        }

        if (checkValue(this.props.heroVideoImageNew, true)) {
          let heroVideoImage: string;
          heroVideoImage = '';
          let heroFilterDev = 'hero-desktop';

          if (heroData.device === 'tablet') {
            heroFilterDev = 'hero-tablet';
          } else if (heroData.device === 'mobile') {
            heroFilterDev = 'hero-mobile';
          }

          let arrFiltered = '';
          this.props.heroVideoImageNew.map(
            (heroVideoItem) => {
              if (heroVideoItem.name === heroFilterDev) {
                arrFiltered = heroVideoItem.url;
              }
            }
          );

          if (checkValue(arrFiltered, true)) {
            heroVideoImage = arrFiltered;
          }

          if (heroVideoImage !== '') {
            videoJsOptions['poster'] = heroVideoImage;
          }
        }

        const { heroVideoWidth, heroVideoHeight } = this.props;

        const videoProps = {
          videoOptions: videoJsOptions,
          width: parseInt(heroVideoWidth),
          height: parseInt(heroVideoHeight)
        };

        const width = checkValue(heroVideoWidth) ? parseInt(heroVideoWidth) : '';

        videoHTML = (
          <div
            className={`t-main-container t-video-container hero-video-container ${checkValue(width) ? 't-video-container-center' : ''}`}
            style={ checkValue(width, false) ? { maxWidth: width + 'px' , marginRight:"auto !important" , marginLeft:"auto"} : { maxWidth: '76.375rem'} }
          >
            <VideoPlayerComponent {...videoProps} isHero={true} wrapperClass="hero-video-container" isHeroPositionStore={true} />
          </div>
        );

        isVideoMode = true;
        wrapperClass = 't-hero-wrapper t-hero-video-wrapper ' + getTemplateType();
        heroTitlesWrapper = 'uitk-cell all-cell-1-1 m-cell-1-1 s-cell-1-1';
      }

      //check for hero background video
      if (checkValue(this.props.heroVideo, true) && this.props.heroVideoPosition === 'Background video') {
        let heroBgVideoURL = '';
        if (checkValue(this.props.heroVideo, true)) {
          heroBgVideoURL = this.props.heroVideo[0]['url'];
        }

        let heroBgVideoImage: string;
        heroBgVideoImage = '';
        if (checkValue(this.props.heroVideoImageNew, true)) {
          let heroFilterDev = 'hero-desktop';
          if (heroData.device === 'tablet') {
            heroFilterDev = 'hero-tablet';
          } else if (heroData.device === 'mobile') {
            heroFilterDev = 'hero-mobile';
          }
          let arrFiltered = '';
          this.props.heroVideoImageNew.map((heroVideoItem) => {
            if (heroVideoItem.name === heroFilterDev) {
              arrFiltered = heroVideoItem.url;
            }
          });
          if (checkValue(arrFiltered, true)) {
            heroBgVideoImage = arrFiltered;
          }
        }
        const videoProps: VideoProps = {
          src: heroBgVideoURL, //16:9 correct video https://mesocp2-2.azureedge.net/media/jameyypk/let-s-plan-to-vacation-again-maj.mp4
          exClass: 'hero-video-background',
          autoPlay: true,
          muted: true,
          loop: true,
          poster: heroBgVideoImage,
          playsInline: true,
        };
        heroBackgroundVideoHTML = <Video {...videoProps} />;

        isHeroBgVideoMode = true;
      }

      const headerLogoSize = checkValue(heroData?.headerLogoSize ) ? heroData?.headerLogoSize?.toLowerCase()  : "";

      const applyOriginalImageRatio =  !isVideoMode && !isHeroBgVideoMode &&
      checkValue(applyOriginalRatioForBackgroundPhoto) &&
      applyOriginalRatioForBackgroundPhoto.toLowerCase() === 'true';

      const contentInner = () => (
        <>
          <span role="figure" aria-label={get(this.props, 'heroImageDescription', 'Hero Image')} />
          {this.props.turnOffGradient == 'False' && <div className={'text-gradient ' + heroGradient}></div>}
          {this.props.turnOffGradient == 'False' && getBreadcums() && (
            <div className="text-gradient top-text-gradient"></div>
          )}
          <div className="t-main-container">
            {getBreadcums()}
            <div className={`spotlight-component-wrapper t-hero-title-cover ${heroTitleStyle} ${(checkValue(heroData?.barColorLeft) || checkValue(heroData?.barColorRight)) ? 'hero-module--stripe' : ''}` }>
              <div className={'t-hero-title-cover ' + heroTitleStyle}>
                <div className="uitk-grid">
                  <div className={heroTitlesWrapper}>
                    <div className="t-hero-titles">
                      <Typo.HTMLText exClass='hero-title override-heading-font-family' tag="h1">{getCurlyQuotes(heroTitle)}</Typo.HTMLText>
                      {!isVideoMode && getSubText()}
                    </div>
                  </div>
                  {isVideoMode && getSubText()}
                </div>
              </div>
            </div>
            {getHeroLogoCentered()}
          </div>
          <CopyrightWithGradientComponent {...copyrightCameraProps} />
        </>
      )
  
      return (
        <div className={`${wrapperClass}
            ${checkValue(headerLogoSize) ? `header-logo-size-${headerLogoSize}` : ""} 
            ${checkValue(heroLogoAlign) && heroLogoAlign === 'centered' ? 'hero-center-image': ''} 
            ${turnOffImagecrop ? 'turn-off-image-crop' : ''}
            ${applyOriginalImageRatio ? 'keep-hero-bg-original-ratio-wrapper' : ''}
            ${checkValue(heroSlimMode) && heroSlimMode.toLowerCase() === 'true' ? ' slim' : ''}
            `}>
          {checkValue(heroData?.barColorLeft) && <div className="hero-module__stripe hero-module__stripe--left"></div>}
          {checkValue(heroData?.barColorRight) && <div className="hero-module__stripe hero-module__stripe--right"></div>}
          { checkValue(heroLogoImage) && heroLogoAlign.toLowerCase() !== 'centered' && !isheroLogoFull &&(
              <div className={`hero-logo hero-logo-${heroLogoAlign} ${heroLogoAlign === 'topleft' || heroLogoAlign === 'topright' ? 'hero-logo--top' : ''}`}>
                <img src={heroLogoImage} />
              </div>
          )}
          {/* Hero Image Content */}
          {!isHeroBgVideoMode && (
            <div className={`
                ${isheroLogoFull ? 'hero-logo-full' : ''}
                t-hero-image ${heroShadowNone}
                ${(this.props.heroStyle === 'Article Style 3') ? 'hero-center' : ''}
                ${applyOriginalImageRatio ? 'keep-hero-bg-original-ratio' : ''}
              `} style={herobgImg}>
              { applyOriginalImageRatio ?
                <div className={`t-hero-content-container ${(this.props.heroStyle === 'Article Style 3') ? 'hero-center' : ''}`}>
                  {contentInner()}
                </div> : contentInner()
              }
            </div>
          )}
          {/*Hero Main Video */}
          {!isHeroBgVideoMode && isVideoMode && videoHTML}

          {/* Hero background video */}
          {isHeroBgVideoMode && (
            <div className="t-hero-video-container" id="hero">
              <div className="hero-video-text-main-container">
                <div className={'spotlight-component-wrapper t-hero-title-cover ' + heroTitleStyle}>
                  <div className="uitk-grid">
                    <div className={heroTitlesWrapper}>
                      <div className="t-hero-titles t-hero-titles-color">
                        <Typo.HTMLText exClass='override-heading-font-family' tag="h1">{heroTitle}</Typo.HTMLText>
                        {getSubText()}
                      </div>
                    </div>
                  </div>
                </div>
                {getHeroLogoCentered()}
              </div>
              {heroBackgroundVideoHTML}
              <CopyrightWithGradientComponent {...copyrightCameraProps} />
            </div>
          )}
          {checkValue(heroData?.heroScrollDownArrow) && (heroData?.heroScrollDownArrow === 'True') && setScrollDownArrow()}
        </div>
      );
    };

    let opecityValue = 1.0;
    if (checkValue(this.props.opacitySelect)) {
      opecityValue = this.props.opacitySelect / 100;
    }

    let keepOriginalRatioStyles = [
      'background-position: center center;',
      'background-size: 100% !important;'
    ];
    if ((checkValue(applyOriginalRatioForBackgroundPhoto) && applyOriginalRatioForBackgroundPhoto.toLowerCase() === 'true')) {
      if (document.body.offsetWidth > 1024) {
        keepOriginalRatioStyles = [
          'padding-bottom: 54% !important;'
        ]
      }
      else if (document.body.offsetWidth > 767) {
        keepOriginalRatioStyles = [
          'padding-bottom: 65% !important;'
        ]
      }
      else if (document.body.offsetWidth > 375) {
        keepOriginalRatioStyles = [
          'padding-bottom: 133% !important;'
        ]
      }
      else {
        keepOriginalRatioStyles = [
          'padding-bottom: 133% !important;',
          'background-position: unset !important;',
          'background-size: cover !important;'
        ]
      }
    }

    const titleSizeDesktopMap: any = setFontSizeHeroModule(this.props.textSize);
    const titleSizeDesktop = titleSizeDesktopMap.desktop;
    const titleSizeMobile = titleSizeDesktopMap.mobile;

    return (
      <>
        <style
          dangerouslySetInnerHTML={{
            __html: `
          .t-hero-wrapper .text-gradient {opacity:${opecityValue};}
          .t-hero-image-large { background-image:url(${heroImage}) !important; }
          ${checkValue(heroData?.barColorLeft) ? `.hero-module__stripe--left { background-color: ${heroData?.barColorLeft} !important;}` : ''}
          ${checkValue(heroData?.barColorRight) ? `.hero-module__stripe--right { background-color: ${heroData?.barColorRight} !important;}` : ''}
          @supports (background-image: filter(url('i.jpg'), blur(1px))) {
            .t-hero-image {
              transform: translateZ(0);
            }
            .t-hero-image-large {
              animation: sharpen 2s both;
            }
            @keyframes sharpen {
              from {
                background-image: filter(url(${heroImage}), blur(20px));
              }
              to {
                background-image: filter(url(${heroImage}), blur(0px));
              }
            }
          }
          ${(checkValue(heroImage) && checkValue(applyOriginalRatioForBackgroundPhoto) && applyOriginalRatioForBackgroundPhoto.toLowerCase() === 'true') ?
          `.keep-hero-bg-original-ratio {
            ${keepOriginalRatioStyles.join('')}
          }` : ''
        }
          ${checkValue(heroData?.backgroundColor) ? `.t-hero-wrapper.t-hero-video-wrapper { background-color: ${heroData?.backgroundColor};}` : ''}
          ${checkValue(heroData?.textColor) ? 
            `.spotlight .t-hero-wrapper .t-hero-titles-color h1.cms-typo { color: ${heroData?.textColor} !important;}
             .spotlight .t-hero-wrapper .t-hero-titles-color .hero-sub-head-color { color: ${heroData?.textColor} !important;}
             .spotlight .t-hero-wrapper .image-copyrights .imgcopy-wrapper { color: ${heroData?.textColor} !important;}
             .spotlight .t-hero-wrapper .t-hero-titles h1.cms-typo { color: ${heroData?.textColor} !important;}
            `
          : ''}
          .spotlight .t-hero-wrapper .t-hero-titles-color h1.cms-typo ,
          .spotlight .t-hero-wrapper .t-hero-titles h1.cms-typo {
            ${checkValue(titleSizeDesktop) ? `
                font-size: ${titleSizeDesktop.fontSize} !important;
                line-height: ${titleSizeDesktop.fontLineHeight} !important;
                ` : ""}            
          }

          @media only screen and (max-width: ${mediaQueries.tab}) {
            .spotlight .t-hero-wrapper .t-hero-titles-color h1.cms-typo ,
            .spotlight .t-hero-wrapper .t-hero-titles h1.cms-typo{
              ${checkValue(titleSizeMobile) ? `
                  font-size: ${titleSizeMobile.fontSize} !important;
                  line-height: ${titleSizeMobile.fontLineHeight} !important;
                  ` : ""}
            }
          }
            .spotlight .t-hero-wrapper .t-hero-titles h1.cms-typo{
              ${checkValue(heroData.heroTitleWidth) ? `
              width: ${heroData.heroTitleWidth};
                  ` : ""}
              
            }
            .spotlight .t-hero-wrapper .t-hero-titles p.cms-typo{
              ${checkValue(heroData.heroSubTextWidth) ? `
              width: ${heroData.heroSubTextWidth};
                  ` : ""}
              
            }
            @media only screen and (max-width: 768px) {
              .spotlight .t-hero-wrapper .t-hero-titles h1.cms-typo{
                ${checkValue(heroData.heroTitleWidth) ? `
                width: 100%;
                  ` : ""}
              }
              .spotlight .t-hero-wrapper .t-hero-titles p.cms-typo{
                ${checkValue(heroData.heroSubTextWidth) ? `
                width: 100%;
                  ` : ""}
              }
            }
          `,
          }}
        ></style>

        {getHeroHTML()}
      </>
    );
  }
}

export default Hero;

export const heroLargImgFn = () => {
  return heroLargImg;
};
